fragment ValueRotationFragment on valueRotation_Entry {
  typeHandle
  tagLine
  valueSlides {
    ... on valueSlidesBlock_Entry {
      claim
    }
  }
}
